import { usePrismicStore } from '@/zustandStore.js';

export const useFeatureFlag = (key: string) => {
    const featureFlags = usePrismicStore((state) => state.featureFlags);

    return !!featureFlags[key];
};
